import { useState } from "react";
import toast from "react-hot-toast";
import { NetworkManager } from "../services";

export const useDownloadCsv = ({ path, filename}) => {
    const [csvLoading, setCsvLoading] = useState(false);


    const downloadCsv = async () => {
        setCsvLoading(true);
        try {
            const csvRes = await NetworkManager.Call({
                method: "get",
                path,
                responseType: "blob"
            })

            // Create a link element
            const link = document.createElement('a');

            // Create a URL for the Blob and set it as the href attribute
            const url = URL.createObjectURL(new Blob([csvRes]));
            link.href = url;

            // Set the download attribute with the desired file name
            link.download = `${new Date().toISOString()}_${filename}`;

            // Programmatically click the link to trigger the download
            link.click();
            // Clean up by revoking the object URL
            URL.revokeObjectURL(url);
        } catch (error) {
            toast.error('Failed to download. Please try again.');
        } finally {
            // Always reset loading state so the button doesn't stay stuck
            // in the "Downloading..." state when the download fails.
            setCsvLoading(false);
        }
    }

    return {
        csvLoading,
        downloadCsv
    }
}